import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  parsePhoneNumberWithError,
  isValidPhoneNumber,
} from 'libphonenumber-js';

export function createPhoneNumberValidator(
  defaultCountry?: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;

    if (!value) {
      return null;
    }

    if (!value.startsWith('+')) {
      return { missingCountryCode: true };
    }

    try {
      const phoneNumber = parsePhoneNumberWithError(
        value,
        defaultCountry as any
      );

      if (!phoneNumber || !isValidPhoneNumber(value, defaultCountry as any)) {
        return { invalidPhoneNumber: true };
      }

      if (!phoneNumber.isPossible()) {
        return { impossiblePhoneNumber: true };
      }

      return null;
    } catch (e) {
      return { invalidPhoneNumber: true };
    }
  };
}
